import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  html,
  body {
    height: 100%;
    width: 100%;
  }
  body {
    margin: 0;
    padding: 0;
    font-family: ${(props) => props.theme.font.face};
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
  }
  p, dl, dd {
    margin: 0;
  }
  #root {
    height: 100%;
  }
  code, pre {
    font-family: Menlo, Consolas, monospace,monospace; /*  This is due to messed up behaviour with monospace font */
  }
`;
